import PreviewHelp from "./components/help/PreviewHelp"
import PreviewMainButton from "./components/main-button/PreviewMainButton"
import PreviewMainPopup from "./components/main-popup/PreviewMainPopup"
import PreviewStep from "./components/step/PreviewStep"
import "../../ressource/css/custoPreview.css"

/**
 * Main preview component that renders the complete Shortways interface.
 * Applies CSS custom properties from parameters and renders all preview components.
 * @param {Object} props
 * @param {Object} props.parameters - Configuration parameters
 * @param {boolean} props.overlayChecked - Overlay checkbox state
 * @param {boolean} props.highlightStrokeChecked - Highlight stroke checkbox state
 * @returns {JSX.Element}
 */
function Preview({ parameters, overlayChecked, highlightStrokeChecked }) {
  if (parameters) {
    Object.keys(parameters).map(element => document.documentElement.style.setProperty(`--${element}`, parameters[element]))
  }

  if (highlightStrokeChecked && parameters?.modalHighlightColor) {
    document.documentElement.style.setProperty("--highlight-stroke", `4px solid ${parameters.modalHighlightColor}`)
  } else {
    document.documentElement.style.setProperty("--highlight-stroke", "none")
  }

  return (
    <div className="shortways">
      <div className="container" style={{ position: "relative" }}>
        <div className="row">
          <div className="col- setColPreview">
            <PreviewMainPopup parameters={parameters} />
          </div>
          <div className="col- setColPreview">
            <PreviewStep parameters={parameters} />
            <PreviewMainButton parameters={parameters} />
            <PreviewHelp />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Preview
